import { render } from "./Navi.vue?vue&type=template&id=8fe259ea"
import script from "./Navi.vue?vue&type=script&lang=js"
export * from "./Navi.vue?vue&type=script&lang=js"

import "./Navi.vue?vue&type=style&index=0&id=8fe259ea&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__